import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SharingRule} from '../api/entity/sharing-rule.model';
import {isNullOrUndefined} from 'util';
import {ControlContainer, NgModelGroup} from '@angular/forms';
import {MoneyPipe} from '../../../shared/pipes/money.pipe';
import {DictionaryObject} from '../../../../../common/api';
import {Share} from '../api/entity/share.model';
import {BENEFICIARY_KIND} from '../api/entity/beneficiary-kind.model';
import {LeaveBlockable} from '../../../shared/leave-block';

@Component({
    selector: 'tfl-revenue-distribution-rules',
    template: require('./distribution-rules.component.html'),
    viewProviders: [{provide: ControlContainer, useExisting: NgModelGroup}],
    providers: [MoneyPipe]
})
export class DistributionRulesComponent implements OnInit {

    @Input('available-beneficiary-kinds') public availableBeneficiaryKinds: string[];
    @Input() rules: SharingRule[];
    @Input('form-group-id') public formGroupId: number = -1;
    @Input('disable-new-rows') public disableNewRows: boolean;
    private _availableFeeServices: DictionaryObject[] = [];
    @Input('profile-id') profileId: number;
    @Output('customChange') customChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    editing: number;
    hovering: number;

    @ViewChild('fg') group: NgModelGroup;

    lastEditedRowNotValid: boolean;
    lastEditedRowErrors = {};
    lastEditedRowHasGroupError: boolean;

    get isSingleRuleLeft(): boolean {
        return this.rules.length <= 1;
    }

    constructor(@Inject('LeaveBlockable') private _lb: LeaveBlockable,
                private _cdr: ChangeDetectorRef) {
    }

    @Input('availableFeeServices')
    set setAvailableFeeServices(services: DictionaryObject[]) {
        this._availableFeeServices = services;
        this.rules.forEach((r) => {
            let availableFee = this._availableFeeServices.find((f) => {
                return f.id === r.fee.id;
            });
            if (availableFee) {
                r.fee = availableFee;
            } else {
                this._availableFeeServices.push(r.fee);
            }
        })
    }

    availableFeeServices(fee: DictionaryObject): DictionaryObject[] {
        return this._availableFeeServices.filter((fs) => {
            return !(this.rules.find((r) => {//filter all fee services already present in the table excluding already selected
                return (!fee || (fee.id !== r.fee.id)) && r.fee.id === fs.id;
            }));
        });
    }

    hasAvailableFees(): boolean {
        return this.availableFeeServices(null).length > 0;
    }


    ngOnInit(): void {
        this.rules.forEach(rule => {//make sure we have models for each rule
            this.availableBeneficiaryKinds.forEach(kind => {
                let share = this.accessShare(this.availableBeneficiaryKinds.indexOf(kind), kind, rule);
                if (isNullOrUndefined(share)) {
                    rule.shares.push({
                        beneficiaryKind: kind,
                        beneficiaryKindId: null,
                        percent: 0
                    })
                }

                if (share.beneficiaryKind === BENEFICIARY_KIND.SYSTEM && isNullOrUndefined(share.amount)) {
                    share.amount = {amount: 0, currency_code: 'EUR'}
                }
            })
        });
    }

    get canNotAddNewRow(): boolean {
        return !this.hasAvailableFees() || this.lastEditedRowNotValid;
    }

    accessShare(ind: number, kind: string, rule: SharingRule) {
        let result = rule.shares[ind];
        if (!result) {
            rule.shares.push({
                percent: 0,
                beneficiaryKind: kind,
                beneficiaryKindId: null
            })
        }
        return result;
    }

    onRowUpdated(state) {
        if (isNullOrUndefined(this.editing)) {
            return;
        }
        this.setRowValidityState(state);
        this._cdr.detectChanges();
    }

    isRemovable(rule: SharingRule) {
        return !rule.mandatory && !this.isSingleRuleLeft;
    }

    editRowAt(rowIndex: number) {
        this.customChange.emit();
        if (this.lastEditedRowNotValid) {
            return;
        }
        this.editing = rowIndex;
        this._cdr.detectChanges();
    }

    removeRowAt(rowIndex: number) {
        this.customChange.emit();
        this.editing = undefined;
        this.setRowValidityState({valid: true, isGroupError: false});
        this.rules.splice(rowIndex, 1);
        this._lb.setComponentAllowedToLeave(false);
        this._cdr.detectChanges();
    }

    private setRowValidityState(state) {
        this.lastEditedRowNotValid = !state.valid;
        this.lastEditedRowErrors = state.errors ? state.errors : {};
        this.lastEditedRowHasGroupError = state.isGroupError;
    }

    closeEditMode() {
        if (!this.lastEditedRowNotValid) {
            if(this.group && this.group.control) {
                this.group.control.enable();//avoids setting form status to disabled after user leaves the form
            }
            this.editing = undefined;
            this._cdr.detectChanges();
        }
    }

    addRow() {
        if (this.canNotAddNewRow) {
            return;
        }
        this.rules.push(this.createRule());
        this.editRowAt(this.rules.length - 1);
        this._lb.setComponentAllowedToLeave(false);
    }

    onRuleHover(event) {
        if (event.hovering) {
            this.hovering = event.index;
        } else {
            this.hovering = undefined;
        }
    }

    private createRule(): SharingRule {
        return {
            fee: this.availableFeeServices(null)[0],
            mandatory: false,
            shares: this.populateShares(this.rules[0].shares)
        }
    }

    //TODO remove duplication
    private populateShares(template: Share[]): Share[] {
        return template.map(t => ({
            percent: t.beneficiaryKind === BENEFICIARY_KIND.SYSTEM ? 100 : 0,
            beneficiaryKind: t.beneficiaryKind,
            beneficiaryKindId: t.beneficiaryKindId
        }))
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/rules/distribution-rules.component.ts